import { RealestateStrategyIcon } from '@/svgs'
import React from 'react'

function FiFromStrategy() {
   return (
      <section id="development-guide-section" className="section_secondary_bg">
         <div className="container">
            <h2 className="section_heading_title mb-3">
               From Vision to Reality: <br />
               Our Real Estate Software Development Process
            </h2>

            <p className="section_desc">
               With 12+ years of expertise in real estate software development,
               we build seamless, scalable, and high-performance solutions. Our
               structured approach enhances property management, simplifies
               transactions, and improves customer engagement.
            </p>

            <RealestateStrategyIcon />
         </div>
      </section>
   )
}

export default FiFromStrategy
